import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a647a550")

_pushScopeId("data-v-a647a550")
const _hoisted_1 = {
  class: "modal fade",
  id: "_app_objective-info_modal",
  tabindex: -1,
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "history-container" }
const _hoisted_8 = { class: "history-item" }
const _hoisted_9 = { class: "history-label" }
const _hoisted_10 = { class: "history-value" }
const _hoisted_11 = { class: "history-item" }
const _hoisted_12 = { class: "history-label" }
const _hoisted_13 = { class: "history-value" }
const _hoisted_14 = { class: "history-item" }
const _hoisted_15 = { class: "history-label" }
const _hoisted_16 = { class: "history-value" }
const _hoisted_17 = { class: "table-container" }
const _hoisted_18 = { class: "table" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h5", _hoisted_5, _toDisplayString($setup.translate("advanceOKR")), 1),
          _createVNode("button", {
            id: "close_main_modal",
            "data-bs-dismiss": "modal",
            "data-bs-target": "#_app_objective_main_modal",
            "data-bs-placement": "top",
            title: $setup.translate('close'),
            class: "btn btn-icon me-n5"
          }, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
          ], 8, ["title"])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("span", _hoisted_9, _toDisplayString($setup.translate("createdBy")) + ":", 1),
              _createVNode("span", _hoisted_10, _toDisplayString($setup.createdByName), 1)
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("span", _hoisted_12, _toDisplayString($setup.translate("createdAt")) + ":", 1),
              _createVNode("span", _hoisted_13, _toDisplayString($setup.formatDate($setup.createdDate)), 1)
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("span", _hoisted_15, _toDisplayString($setup.translate("lastEdited")) + ":", 1),
              _createVNode("span", _hoisted_16, _toDisplayString($setup.lastEditedByName), 1)
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("table", _hoisted_18, [
              _createVNode("thead", null, [
                _createVNode("tr", null, [
                  _createVNode("th", null, _toDisplayString($setup.translate("user")), 1),
                  _createVNode("th", null, _toDisplayString($setup.translate("advance")), 1),
                  _createVNode("th", null, _toDisplayString($setup.translate("date")), 1)
                ])
              ]),
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.changes.slice().reverse(), (change, index) => {
                  return (_openBlock(), _createBlock("tr", { key: index }, [
                    _createVNode("td", null, _toDisplayString(change.name + " " + change.lastname), 1),
                    _createVNode("td", null, _toDisplayString(change.advance), 1),
                    _createVNode("td", null, _toDisplayString($setup.formatDate(change.logged_at)), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
})